// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"e91687b1","423":"143cefe3","462":"685fa664","849":"c4d44797"}[chunkId] + ".chunk.js";
};